import i18n from "i18next";
import qs from "qs";
import { initReactI18next } from "react-i18next";
const zh_hans = {
  "game_running": "已开始",
  "connect_box": "联机面板",
  "close": "关闭",
  "nickname": "昵称",
  "connect": "连接",
  "connecting": "连接中",
  "disconnect": "断开链接",
  "address": "地址",
  "yourself": "你",
  "cancal_ready": "取消准备",
  "get_ready": "准备！",
  "kick": "请出房间",
  "leave_room": "退出房间",
  "ready_completed": "准备就绪",
  "not_ready": "",
  "counting_down": "即将开始，倒计时: %1秒",
  "refresh": "刷新",
  "auto_refresh": "自动刷新",
  "create_room": "创建房间",
  "sync_mode": "同步模式",
  "sync_auto": "自动",
  "sync_lockstep": "锁帧",
  "sync_delay": "延迟",
  "sync_recommend": "推荐",
  "join": "加入",
  "room_name": "房名",
  "player_count": "人数",
  "room_owner": "房主",
  "room_code": "房间号",
  "waiting": "等待中",
  "prev_page": "上一页",
  "next_page": "下一页",
  "rooms_total": "共 %1 个房间",
  "room_list": "房间列表",
  "no_rooms": "暂无房间，点击刷新或创建房间",
  "load_finished": "加载完毕",
  "lfw_version": "LFW 版本",
  "data_package": "数据包",
  "password": "密码",
  "dont_need_password": "任意人可加入",
  "pls_enter_pwd": "输入房间密码",
  "custom_game": "自定义游戏",
  "pls_drag_game_zip_in_here": "点击此处选择「游戏数据包」\n或 将「游戏数据包」拖拽至此以加载自定义游戏",
  "download_origin_full_zip_here": "下载原始「游戏数据包」",
  "bgm_volume": "BGM 音量",
  "sfx_volume": "SFX 音量",
  "sync_0": "無限",
  "sync_1": "同步",
  "sync_2": "60 FPS",
  "sync_3": "120 FPS",
  "team_outline": "队伍描边",
  "enabled": "已启用",
  "disabled": "已禁用",
  "return_to_game": "回到游戏页",
  "update_checking": "正在检查更新…",
  "update_downloading": "正在下载新版本 %1（%2%）",
  "update_ready": "新版本 %1 已下载，重启后生效",
  "update_restart": "重启并更新",
  "update_up_to_date": "已是最新版本",
  "update_failed": "检查更新失败",
}
const zh_hant = {
  "game_running": "已開始",
  "connect_box": "聯機面板",
  "close": "關閉",
  "nickname": "暱稱",
  "connect": "連接",
  "connecting": "連接中",
  "disconnect": "斷開連接",
  "address": "地址",
  "yourself": "你",
  "cancal_ready": "取消準備",
  "get_ready": "準備！",
  "kick": "請出房間",
  "leave_room": "退出房間",
  "ready_completed": "準備就緒",
  "not_ready": "",
  "counting_down": "即將開始，倒數計時: %1秒",
  "refresh": "刷新",
  "auto_refresh": "自動刷新",
  "create_room": "創建房間",
  "sync_mode": "同步模式",
  "sync_auto": "自動",
  "sync_lockstep": "鎖幀",
  "sync_delay": "延遲",
  "sync_recommend": "推薦",
  "join": "加入",
  "room_name": "房名",
  "player_count": "人數",
  "room_owner": "房主",
  "room_code": "房間號",
  "waiting": "等待中",
  "prev_page": "上一頁",
  "next_page": "下一頁",
  "rooms_total": "共 %1 個房間",
  "room_list": "房間列表",
  "no_rooms": "暫無房間，點擊刷新或創建房間",
  "load_finished": "加载完毕",
  "lfw_version": "LFW 版本",
  "data_package": "數據包",
  "password": "密碼",
  "dont_need_password": "任意人可加入",
  "pls_enter_pwd": "輸入房間密碼",
  "custom_game": "自訂遊戲",
  "pls_drag_game_zip_in_here": "點擊此處選擇「遊戲數據包」\n或 將「遊戲數據包」拖曳至此以加載自定義遊戲",
  "download_origin_full_zip_here": "下载原始「遊戲數據包」",
  "bgm_volume": "BGM 音量",
  "sfx_volume": "SFX 音量",
  "team_outline": "隊伍輪廓",
  "enabled": "已啟用",
  "disabled": "已禁用",
  "return_to_game": "回到游戏页",
  "update_checking": "正在檢查更新…",
  "update_downloading": "正在下載新版本 %1（%2%）",
  "update_ready": "新版本 %1 已下載，重新啟動後生效",
  "update_restart": "重新啟動並更新",
  "update_up_to_date": "已是最新版本",
  "update_failed": "檢查更新失敗",
}
const fr = {
  "game_running": "Démarré",
  "connect_box": "Panneau de connexion",
  "close": "Fermer",
  "nickname": "Pseudo",
  "connect": "Se connecter",
  "connecting": "Connexion en cours",
  "disconnect": "Se déconnecter",
  "address": "Adresse",
  "yourself": "Vous",
  "cancal_ready": "Annuler le prêt",
  "get_ready": "Prêt !",
  "kick": "Expulser",
  "leave_room": "Quitter",
  "ready_completed": "Prêt !",
  "not_ready": "",
  "counting_down": "Compte à rebours : %1 s",
  "refresh": "Actualiser",
  "auto_refresh": "Actualisation auto",
  "create_room": "Créer une salle",
  "sync_mode": "Mode de synchro",
  "sync_auto": "Auto",
  "sync_lockstep": "Lockstep",
  "sync_delay": "Délai",
  "sync_recommend": "Recommandé",
  "join": "Rejoindre",
  "room_name": "Nom de la salle",
  "player_count": "Joueurs",
  "room_owner": "Hôte",
  "room_code": "N° de salle",
  "waiting": "En attente",
  "prev_page": "Page précédente",
  "next_page": "Page suivante",
  "rooms_total": "%1 salle(s) au total",
  "room_list": "Liste des salles",
  "no_rooms": "Aucune salle disponible. Cliquez sur Actualiser ou Créer une salle",
  "load_finished": "Chargement terminé",
  "lfw_version": "Version LFW",
  "data_package": "Pack de données",
  "password": "Mot de passe",
  "dont_need_password": "N’importe qui peut rejoindre.",
  "pls_enter_pwd": "Saisir le mot de passe",
  "custom_game": "Jeu personnalisé",
  "pls_drag_game_zip_in_here": "Cliquez ici pour sélectionner « Archive de données du jeu ».\nOu glissez « Archive de données du jeu » ici pour charger le jeu personnalisé.",
  "custom_game_drop_err_0": "Les fichiers multiples ne sont pas pris en charge",
  "custom_game_drop_err_1": "Ce que vous avez déposé n’est pas un fichier",
  "custom_game_drop_err_2": "Fichier reçu : %1, pourquoi ?",
  "custom_game_load_file_err_0": '"index.json" ou "index.json5" introuvable',
  "custom_game_load_file_err_1": 'le contenu de "index.json" doit être un tableau de chaînes d’une longueur supérieure à 2',
  "custom_game_load_file_err_2": "$1 introuvable",
  "custom_game_load_file_err_3": "les données ne sont pas ",
  "custom_game_load_file_err_4": '"type" doit être "FULL"',
  "custom_game_load_file_err_5": '"version" doit être "number"',
  "custom_game_load_file_err_6": "version incorrecte",
  "download_origin_full_zip_here": "Télécharger « Archive de données du jeu » d’origine",
  "bgm_volume": "Volume BGM",
  "sfx_volume": "Volume SFX",
  "sync_0": "Non synchronisé",
  "sync_1": "Sync 60 FPS",
  "sync_2": "Sync 30 FPS",
  "team_outline": "Contour d’équipe",
  "enabled": "Activé",
  "disabled": "Désactivé",
  "return_to_game": "Retourner au jeu",  "update_checking": "Vérification des mises à jour…",
  "update_downloading": "Téléchargement de la version %1 (%2%)",
  "update_ready": "Version %1 téléchargée, effective après redémarrage",
  "update_restart": "Redémarrer et mettre à jour",
  "update_up_to_date": "Déjà à jour",
  "update_failed": "Échec de la vérification des mises à jour",}
const ru = {
  "game_running": "Начата",
  "connect_box": "Панель подключения",
  "close": "Закрыть",
  "nickname": "Ник",
  "connect": "Подключиться",
  "connecting": "Подключение",
  "disconnect": "Отключиться",
  "address": "Адрес",
  "yourself": "Вы",
  "cancal_ready": "Отменить готовность",
  "get_ready": "Готов!",
  "kick": "Выгнать",
  "leave_room": "Выйти",
  "ready_completed": "Готов!",
  "not_ready": "",
  "counting_down": "Скоро начало, отсчёт: %1 с",
  "refresh": "Обновить",
  "auto_refresh": "Автообновление",
  "create_room": "Создать комнату",
  "sync_mode": "Синхронизация",
  "sync_auto": "Авто",
  "sync_lockstep": "Локстеп",
  "sync_delay": "Задержка",
  "sync_recommend": "Рекомендуется",
  "join": "Войти",
  "room_name": "Название комнаты",
  "player_count": "Игроки",
  "room_owner": "Хозяин",
  "room_code": "Код комнаты",
  "waiting": "Ожидание",
  "prev_page": "Предыдущая страница",
  "next_page": "Следующая страница",
  "rooms_total": "Всего комнат: %1",
  "room_list": "Список комнат",
  "no_rooms": "Нет доступных комнат. Нажмите «Обновить» или «Создать комнату»",
  "load_finished": "Загрузка завершена",
  "lfw_version": "Версия LFW",
  "data_package": "Пакет данных",
  "password": "Пароль",
  "dont_need_password": "Присоединиться может любой.",
  "pls_enter_pwd": "Введите пароль",
  "custom_game": "Пользовательская игра",
  "pls_drag_game_zip_in_here": "Нажмите здесь, чтобы выбрать «Архив данных игры».\nИли перетащите «Архив данных игры» сюда, чтобы загрузить пользовательскую игру.",
  "custom_game_drop_err_0": "Несколько файлов не поддерживается",
  "custom_game_drop_err_1": "То, что вы перетащили, не является файлом",
  "custom_game_drop_err_2": "Файл получен: %1, почему?",
  "custom_game_load_file_err_0": '"index.json" или "index.json5" не найдены',
  "custom_game_load_file_err_1": 'содержимое "index.json" должно быть строковым массивом длиной более 2',
  "custom_game_load_file_err_2": "$1 не найден",
  "custom_game_load_file_err_3": "данные не ",
  "custom_game_load_file_err_4": '"type" должно быть "FULL"',
  "custom_game_load_file_err_5": '"version" должно быть "number"',
  "custom_game_load_file_err_6": "неверная версия",
  "download_origin_full_zip_here": "Скачать оригинальный «Архив данных игры»",
  "bgm_volume": "Громкость BGM",
  "sfx_volume": "Громкость SFX",
  "sync_0": "Без синхронизации",
  "sync_1": "Синхронизация 60 FPS",
  "sync_2": "Синхронизация 30 FPS",
  "team_outline": "Контур команды",
  "enabled": "Включено",
  "disabled": "Отключено",
  "return_to_game": "Вернуться в игру",
  "update_checking": "Проверка обновлений…",
  "update_downloading": "Загрузка версии %1 (%2%)",
  "update_ready": "Версия %1 загружена, применится после перезапуска",
  "update_restart": "Перезапустить и обновить",
  "update_up_to_date": "Установлена последняя версия",
  "update_failed": "Не удалось проверить обновления",
}
const es = {
  "game_running": "Iniciado",
  "connect_box": "Panel de conexión",
  "close": "Cerrar",
  "nickname": "Apodo",
  "connect": "Conectar",
  "connecting": "Conectando",
  "disconnect": "Desconectar",
  "address": "Dirección",
  "yourself": "Tú",
  "cancal_ready": "Cancelar listo",
  "get_ready": "¡Listo!",
  "kick": "Expulsar",
  "leave_room": "Salir",
  "ready_completed": "¡Listo!",
  "not_ready": "",
  "counting_down": "Comienza pronto, cuenta atrás: %1 s",
  "refresh": "Actualizar",
  "auto_refresh": "Actualización automática",
  "create_room": "Crear sala",
  "sync_mode": "Sincronización",
  "sync_auto": "Auto",
  "sync_lockstep": "Lockstep",
  "sync_delay": "Retardo",
  "sync_recommend": "Recomendado",
  "join": "Unirse",
  "room_name": "Nombre de la sala",
  "player_count": "Jugadores",
  "room_owner": "Anfitrión",
  "room_code": "Código de sala",
  "waiting": "En espera",
  "prev_page": "Página anterior",
  "next_page": "Página siguiente",
  "rooms_total": "%1 sala(s) en total",
  "room_list": "Lista de salas",
  "no_rooms": "No hay salas disponibles. Haz clic en Actualizar o Crear sala",
  "load_finished": "Carga completada",
  "lfw_version": "Versión LFW",
  "data_package": "Paquete de datos",
  "password": "Contraseña",
  "dont_need_password": "Cualquiera puede unirse.",
  "pls_enter_pwd": "Introducir contraseña",
  "custom_game": "Juego personalizado",
  "pls_drag_game_zip_in_here": "Haz clic aquí para seleccionar «Paquete de datos del juego».\nO arrastra «Paquete de datos del juego» aquí para cargar el juego personalizado.",
  "custom_game_drop_err_0": "No se admiten varios archivos",
  "custom_game_drop_err_1": "Lo que arrastraste no es un archivo",
  "custom_game_drop_err_2": "Archivo recibido: %1, ¿por qué?",
  "custom_game_load_file_err_0": 'No se encontró "index.json" ni "index.json5"',
  "custom_game_load_file_err_1": 'el contenido de "index.json" debe ser una matriz de cadenas con una longitud superior a 2',
  "custom_game_load_file_err_2": "No se encontró $1",
  "custom_game_load_file_err_3": "los datos no ",
  "custom_game_load_file_err_4": '"type" debe ser "FULL"',
  "custom_game_load_file_err_5": '"version" debe ser "number"',
  "custom_game_load_file_err_6": "versión incorrecta",
  "download_origin_full_zip_here": "Descargar «Paquete de datos del juego» original",
  "bgm_volume": "Volumen BGM",
  "sfx_volume": "Volumen SFX",
  "sync_0": "Sin sincronización",
  "sync_1": "Sincronizar 60 FPS",
  "sync_2": "Sincronizar 30 FPS",
  "team_outline": "Contorno de equipo",
  "enabled": "Habilitado",
  "disabled": "Deshabilitado",
  "return_to_game": "Volver al juego",
  "update_checking": "Buscando actualizaciones…",
  "update_downloading": "Descargando la versión %1 (%2%)",
  "update_ready": "Versión %1 descargada, se aplicará al reiniciar",
  "update_restart": "Reiniciar y actualizar",
  "update_up_to_date": "Ya está actualizado",
  "update_failed": "Error al buscar actualizaciones",
}
const pt = {
  "game_running": "Iniciado",
  "connect_box": "Painel de conexão",
  "close": "Fechar",
  "nickname": "Apelido",
  "connect": "Conectar",
  "connecting": "Conectando",
  "disconnect": "Desconectar",
  "address": "Endereço",
  "yourself": "Você",
  "cancal_ready": "Cancelar pronto",
  "get_ready": "Pronto!",
  "kick": "Expulsar",
  "leave_room": "Sair",
  "ready_completed": "Pronto!",
  "not_ready": "",
  "counting_down": "Começa em breve, contagem regressiva: %1 s",
  "refresh": "Atualizar",
  "auto_refresh": "Atualização automática",
  "create_room": "Criar sala",
  "sync_mode": "Sincronização",
  "sync_auto": "Auto",
  "sync_lockstep": "Lockstep",
  "sync_delay": "Atraso",
  "sync_recommend": "Recomendado",
  "join": "Entrar",
  "room_name": "Nome da sala",
  "player_count": "Jogadores",
  "room_owner": "Dono",
  "room_code": "Código da sala",
  "waiting": "Aguardando",
  "prev_page": "Página anterior",
  "next_page": "Página seguinte",
  "rooms_total": "%1 sala(s) no total",
  "room_list": "Lista de salas",
  "no_rooms": "Nenhuma sala disponível. Clique em Atualizar ou Criar sala",
  "load_finished": "Carregamento concluído",
  "lfw_version": "Versão LFW",
  "data_package": "Pacote de dados",
  "password": "Senha",
  "dont_need_password": "Qualquer pessoa pode entrar.",
  "pls_enter_pwd": "Digitar a senha",
  "custom_game": "Jogo personalizado",
  "pls_drag_game_zip_in_here": "Clique aqui para selecionar «Pacote de dados do jogo».\nOu arraste «Pacote de dados do jogo» aqui para carregar o jogo personalizado.",
  "custom_game_drop_err_0": "Vários arquivos não são suportados",
  "custom_game_drop_err_1": "O que você arrastou não é um arquivo",
  "custom_game_drop_err_2": "Arquivo recebido: %1, por quê?",
  "custom_game_load_file_err_0": '"index.json" ou "index.json5" não encontrados',
  "custom_game_load_file_err_1": 'o conteúdo de "index.json" deve ser uma matriz de strings com comprimento superior a 2',
  "custom_game_load_file_err_2": "$1 não encontrado",
  "custom_game_load_file_err_3": "os dados não ",
  "custom_game_load_file_err_4": '"type" deve ser "FULL"',
  "custom_game_load_file_err_5": '"version" deve ser "number"',
  "custom_game_load_file_err_6": "versão incorreta",
  "download_origin_full_zip_here": "Baixar «Pacote de dados do jogo» original",
  "bgm_volume": "Volume do BGM",
  "sfx_volume": "Volume do SFX",
  "sync_0": "Sem sincronização",
  "sync_1": "Sincronizar 60 FPS",
  "sync_2": "Sincronizar 30 FPS",
  "team_outline": "Contorno da equipe",
  "enabled": "Ativado",
  "disabled": "Desativado",
  "return_to_game": "Voltar ao jogo",
  "update_checking": "Verificando atualizações…",
  "update_downloading": "Baixando a versão %1 (%2%)",
  "update_ready": "Versão %1 baixada, aplicada ao reiniciar",
  "update_restart": "Reiniciar e atualizar",
  "update_up_to_date": "Já está atualizado",
  "update_failed": "Falha ao verificar atualizações",
}
const ja = {
  "game_running": "開始済み",
  "connect_box": "接続パネル",
  "close": "閉じる",
  "nickname": "ニックネーム",
  "connect": "接続",
  "connecting": "接続中",
  "disconnect": "切断",
  "address": "アドレス",
  "yourself": "あなた",
  "cancal_ready": "準備をキャンセル",
  "get_ready": "準備！",
  "kick": "キック",
  "leave_room": "退出",
  "ready_completed": "準備完了",
  "not_ready": "",
  "counting_down": "まもなく開始、カウントダウン: %1秒",
  "refresh": "更新",
  "auto_refresh": "自動更新",
  "create_room": "部屋を作成",
  "sync_mode": "同期方式",
  "sync_auto": "自動",
  "sync_lockstep": "全員同期",
  "sync_delay": "遅延入力",
  "sync_recommend": "推奨",
  "join": "参加",
  "room_name": "部屋名",
  "player_count": "人数",
  "room_owner": "部屋主",
  "room_code": "部屋番号",
  "waiting": "待機中",
  "prev_page": "前のページ",
  "next_page": "次のページ",
  "rooms_total": "全 %1 部屋",
  "room_list": "部屋リスト",
  "no_rooms": "利用可能な部屋がありません。「更新」または「部屋を作成」をクリックしてください",
  "load_finished": "読み込み完了",
  "lfw_version": "LFW バージョン",
  "data_package": "データパック",
  "password": "パスワード",
  "dont_need_password": "誰でも参加できます。",
  "pls_enter_pwd": "パスワードを入力",
  "custom_game": "カスタムゲーム",
  "pls_drag_game_zip_in_here": "ここをクリックして「ゲームデータパック」を選択してください。\nまたは「ゲームデータパック」をここにドラッグしてカスタムゲームを読み込みます。",
  "custom_game_drop_err_0": "複数のファイルはサポートされていません",
  "custom_game_drop_err_1": "ドラッグしたものはファイルではありません",
  "custom_game_drop_err_2": "ファイルを受信しました: %1、なぜ？",
  "custom_game_load_file_err_0": '"index.json" または "index.json5" が見つかりません',
  "custom_game_load_file_err_1": '"index.json" の内容は、長さが 2 より大きい文字列配列である必要があります',
  "custom_game_load_file_err_2": "$1 が見つかりません",
  "custom_game_load_file_err_3": "データが ",
  "custom_game_load_file_err_4": '"type" は "FULL" である必要があります',
  "custom_game_load_file_err_5": '"version" は "number" である必要があります',
  "custom_game_load_file_err_6": "バージョンが正しくありません",
  "download_origin_full_zip_here": "オリジナル「ゲームデータパック」をダウンロード",
  "bgm_volume": "BGM 音量",
  "sfx_volume": "SFX 音量",
  "sync_0": "非同期",
  "sync_1": "同期 60 FPS",
  "sync_2": "同期 30 FPS",
  "team_outline": "チームの輪郭",
  "enabled": "有効",
  "disabled": "無効",
  "return_to_game": "ゲームに戻る",
  "update_checking": "更新を確認しています…",
  "update_downloading": "新バージョン %1 をダウンロード中（%2%）",
  "update_ready": "新バージョン %1 をダウンロードしました。再起動後に適用されます",
  "update_restart": "再起動して更新",
  "update_up_to_date": "最新バージョンです",
  "update_failed": "更新の確認に失敗しました",
}
const ko = {
  "game_running": "시작됨",
  "connect_box": "연결 패널",
  "close": "닫기",
  "nickname": "닉네임",
  "connect": "연결",
  "connecting": "연결 중",
  "disconnect": "연결 끊기",
  "address": "주소",
  "yourself": "나",
  "cancal_ready": "준비 취소",
  "get_ready": "준비!",
  "kick": "강퇴",
  "leave_room": "나가기",
  "ready_completed": "준비 완료",
  "not_ready": "",
  "counting_down": "곧 시작, 카운트다운: %1초",
  "refresh": "새로고침",
  "auto_refresh": "자동 새로고침",
  "create_room": "방 만들기",
  "sync_mode": "동기화 모드",
  "sync_auto": "자동",
  "sync_lockstep": "락스텝",
  "sync_delay": "지연 입력",
  "sync_recommend": "추천",
  "join": "참가",
  "room_name": "방 이름",
  "player_count": "인원",
  "room_owner": "방장",
  "room_code": "방 번호",
  "waiting": "대기 중",
  "prev_page": "이전 페이지",
  "next_page": "다음 페이지",
  "rooms_total": "총 %1개 방",
  "room_list": "방 목록",
  "no_rooms": "사용 가능한 방이 없습니다. 새로고침 또는 방 만들기를 클릭하세요",
  "load_finished": "로딩 완료",
  "lfw_version": "LFW 버전",
  "data_package": "데이터 팩",
  "password": "비밀번호",
  "dont_need_password": "누구나 참가할 수 있습니다.",
  "pls_enter_pwd": "비밀번호 입력",
  "custom_game": "커스텀 게임",
  "pls_drag_game_zip_in_here": "여기를 클릭하여 「게임 데이터 팩」을 선택하세요.\n또는 「게임 데이터 팩」을 여기로 끌어다 놓아 커스텀 게임을 불러오세요.",
  "custom_game_drop_err_0": "여러 파일은 지원되지 않습니다",
  "custom_game_drop_err_1": "끌어다 놓은 항목은 파일이 아닙니다",
  "custom_game_drop_err_2": "파일을 받았습니다: %1, 왜?",
  "custom_game_load_file_err_0": '"index.json" 또는 "index.json5"를 찾을 수 없습니다',
  "custom_game_load_file_err_1": '"index.json"의 내용은 길이가 2보다 큰 문자열 배열이어야 합니다',
  "custom_game_load_file_err_2": "$1을 찾을 수 없습니다",
  "custom_game_load_file_err_3": "데이터가 ",
  "custom_game_load_file_err_4": '"type"은 "FULL"이어야 합니다',
  "custom_game_load_file_err_5": '"version"은 "number"이어야 합니다',
  "custom_game_load_file_err_6": "버전이 올바르지 않습니다",
  "download_origin_full_zip_here": "원본「게임 데이터 팩」다운로드",
  "bgm_volume": "BGM 볼륨",
  "sfx_volume": "SFX 볼륨",
  "sync_0": "비동기",
  "sync_1": "동기화 60 FPS",
  "sync_2": "동기화 30 FPS",
  "team_outline": "팀 외곽선",
  "enabled": "활성화됨",
  "disabled": "비활성화됨",
  "return_to_game": "게임으로 돌아가기",
  "update_checking": "업데이트 확인 중…",
  "update_downloading": "새 버전 %1 다운로드 중 (%2%)",
  "update_ready": "새 버전 %1 다운로드 완료, 재시작 후 적용됩니다",
  "update_restart": "재시작 후 업데이트",
  "update_up_to_date": "최신 버전입니다",
  "update_failed": "업데이트 확인 실패",
}
const en = {
  "game_running": "Started",
  "connect_box": "Connect Panel",
  "close": "Close",
  "nickname": 'Nick Name',
  "connect": "Connect",
  "connecting": "Connecting",
  "disconnect": "Disconnect",
  "address": "Address",
  "yourself": "Yourself",
  "cancal_ready": "Cancel Ready",
  "get_ready": "Ready!",
  "kick": "kick",
  "leave_room": "Leave",
  "ready_completed": "Ready!",
  "not_ready": "",
  "counting_down": "Starting Soon, Countdown: %1s",
  "refresh": "Refresh",
  "auto_refresh": "Auto Refresh",
  "create_room": "Create Room",
  "sync_mode": "Sync Mode",
  "sync_auto": "Auto",
  "sync_lockstep": "Lockstep",
  "sync_delay": "Delay",
  "sync_recommend": "Recommend",
  "join": "Join",
  "room_name": "Room Name",
  "player_count": "Players",
  "room_owner": "Owner",
  "room_code": "Room code",
  "waiting": "Waiting",
  "prev_page": "Previous page",
  "next_page": "Next page",
  "rooms_total": "%1 room(s)",
  "room_list": "Room List",
  "no_rooms": "No Rooms Available. Click Refresh or Create Room",
  "load_finished": "Load Finished",
  "lfw_version": "LFW Version",
  "data_package": "Data Pkg",
  "password": "Password",
  "dont_need_password": "Anyone can join.",
  "pls_enter_pwd": "Enter password",
  "custom_game": "Custom Game",
  "pls_drag_game_zip_in_here": "Click here to select the \"Game Data Zip\".\nOr drag the \"Game Data Zip\" here to load the custom game.",
  "custom_game_drop_err_0": "multiple files are not supported",
  "custom_game_drop_err_1": "what you dragged in is not a file",
  "custom_game_drop_err_2": "file got %1, why?",
  "custom_game_load_file_err_0": '"index.json" or "index.json5" not found',
  "custom_game_load_file_err_1": 'content of "index.json" should be a string array with a length more than 2',
  "custom_game_load_file_err_2": '$1 not found',
  "custom_game_load_file_err_3": 'datas not ',
  "custom_game_load_file_err_4": '"type" should be "FULL"',
  "custom_game_load_file_err_5": '"version" should be "number"',
  "custom_game_load_file_err_6": 'wrong version',
  "download_origin_full_zip_here": "Download origin \"Game Data Zip\"",
  "bgm_volume": "BGM Volume",
  "sfx_volume": "SFX Volume",
  "sync_0": "Unsafed",
  "sync_1": "Sync 60FPS",
  "sync_2": "Sync 30FPS",
  "team_outline": "Team Outline",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "return_to_game": "Return to Game",
  "update_checking": "Checking for updates…",
  "update_downloading": "Downloading version %1 (%2%)",
  "update_ready": "Version %1 downloaded, applied after restart",
  "update_restart": "Restart and update",
  "update_up_to_date": "Already up to date",
  "update_failed": "Update check failed",
}
const resources = {
  "zh": { translation: zh_hans },
  "zh-Hans": { translation: zh_hans },
  "zh-CN": { translation: zh_hans },
  "zh-SG": { translation: zh_hans },
  "zh-MY": { translation: zh_hans },
  "zh-Hant": { translation: zh_hant },
  "zh-TW": { translation: zh_hant },
  "zh-HK": { translation: zh_hant },
  "zh-MO": { translation: zh_hant },
  fr: { translation: fr },
  ru: { translation: ru },
  es: { translation: es },
  pt: { translation: pt },
  ja: { translation: ja },
  ko: { translation: ko },
  en: { translation: en }
};
const hobj = qs.parse(location.hash.substring(1))
const sobj = qs.parse(location.search.substring(1))
const hsobj = location.hash.indexOf('?') >= 1 ? qs.parse(location.hash.substring(location.hash.indexOf('?') + 1)) : {}
const lang = sobj.lang || hobj.lang || hsobj.lang;
i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: typeof lang === 'string' ? lang : navigator.language,
    interpolation: { escapeValue: false }
  });

export default i18n;